export default {
    closeAllConditions(search) {
        search.filters.enable = false;
        search.order.enable = false;
        search.limit.enable = false;
        search.excelExport.enable = false;
    },
    getSizeConfig() {
        return [10, 20, 50, '所有'];
    },
    getSearchParams(opt = null) {
        let condition = {
            filters: {
                enable: false,
                conditions: []
            },
            order: {
                enable: false,
                conditions: []
            },
            limit: {
                enable: true,
                conditions: {
                    pageLength: 10,
                    pageStart: 1,
                    total: 0
                }
            },
            excelExport: {
                enable: false,
                columns: []
            }
        };

        if (opt && opt.hasOwnProperty('closeAllConditions') && opt.closeAllConditions) {
            this.closeAllConditions(condition);
        }

        return condition;
    },
    globalPageOnChange(search, pageIndex) {
        search.limit.conditions.pageStart = pageIndex;
    },
    globalResetSearch(search) {
        search.limit.conditions.pageStart = 1;
    },
    globalSetFilterRecordCount(search, count) {
        search.limit.conditions.total = count;
    },
    globalSetFilterPageLength(search, pageLength) {
        search.limit.conditions.pageLength = pageLength;
    },
    globalRemoveFilterConditionKey(search, conditionName) {
        let index = search.filters.conditions.findIndex(e => {
            return e.name === conditionName;
        });
        if (index !== -1) {
            search.filters.conditions.splice(index, 1);
        }
    },
    globalRemoveOrderConditionKey(search, conditionName) {
        let index = search.order.conditions.findIndex(e => {
            return e.name === conditionName;
        });
        if (index !== -1) {
            search.order.conditions.splice(index, 1);
        }
    },
    globalSizeOnChange(search, pageSize) {
        if (pageSize !== '所有') {
            search.limit.enable = true;
            search.limit.conditions.pageStart = 1;
            search.limit.conditions.pageLength = pageSize;
        }
        else {
            search.limit.enable = false;
        }
    },
    globalSetFilterWithSearchForm(search, form) {
        search.filters.enable = form.length > 0;
        let conditions = form.map(v => {
            return { name: v.name, type: v.sql, value: v.value };
        });
        search.filters.conditions = conditions;
        search.limit.conditions.pageStart = 1;
    },
    deepClone(search) {
        return JSON.parse(JSON.stringify(search));
    }
};


// WEBPACK FOOTER //
// ./src/libs/search.js